<h5 mat-dialog-title class="modal_title flex">
    {{"CAMPAIGN.PAUSE_CAMPAIGN" | translate}}
    <mat-icon svgIcon="mat_outline:close"
        class="ml-auto max-w-[22px] max-h-[22px] text-[#0b0d13] font-medium cursor-pointer leading-none min-w-[22px] text-[22px] min-h-[22px]"
        mat-dialog-close></mat-icon>
</h5>
<mat-dialog-content class="modal_body">
    <div>
        <p class="text-md font-normal leading-5 text-[#7D7F86]">{{"CAMPAIGN.CAMPAIGN_PUSH_ACTION" | translate}}
            <span class="text-[#0B0D13] font-medium">{{api?.campaignName}}</span>, {{"CAMPAIGN.MANUALLY_PAUSED_STATUS" |
            translate}} <a class="text-primary" href="javascript:void(0)">{{"CAMPAIGN.RESHEDULING_SELECTED_PROSPECT"
                | translate}}</a>
        </p>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="start" class="form_action">
    <btn-loading type="submit" color="primary" (click)="pauseCampaign()"
        btnClass="text-custom text-md text-custom font-medium leading-[14px] min-h-[34px] max-h-[34px] rounded"
        [loading]="loading">
        {{"CAMPAIGN.CONTINUE" | translate}}
    </btn-loading>
    <button *ngIf="!loading" matRipple class="cancel_btn" mat-dialog-close>{{ "GENERAL.CANCEL" | translate
        }}</button>
</mat-dialog-actions>
